import React from "react";
import { Outlet } from "react-router-dom";

import Header from "./Header/Header";
import Footer from "./Footer/Footer";
import BackToTop from "../common/BackToTop";

export default function PublicLayout() {
  return (
    <div
      dir="rtl"
      className="relative min-h-screen text-slate-900"
    >
      <Header />

      {/* فاصله‌ی هدر شناور */}
      <main className="min-h-[60vh] pt-[84px]">
        <Outlet />
      </main>

      <Footer />

      <BackToTop />
    </div>
  );
}
